// CHEMIN COMPLET : /src/hook/useEnterprise.js

import { useState } from 'react'
import { filter, isNumber, uniq } from 'lodash'
import { getEnterpriseData } from '../api/cbe-api'
import { getNaceWithSector } from '../api/digiscore-api'

export default function useEnterprise({ t, token }) {
  const [enterpriseName, setEnterpriseName] = useState('')
  const [sectors, setSectors] = useState([])
  const [address, setAddress] = useState()
  const [bceValue, setBceValue] = useState('')
  const [errorBce, setErrorBce] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const checkFormatEnterpriseNumber = (val) => {
    if (!val) return false
    let text = val.split('.').join('')
    const num = Number(text)
    if (isNumber(num)) {
      if (!num.toString().startsWith('0') && num.toString().length === 9) {
        text = '0' + num
      }
    }
    return text
  }

  const fetchEnterprise = async (rawBce) => {
    setErrorBce('')
    setErrorMessage('')

    const formatted = checkFormatEnterpriseNumber(rawBce)

    const surveys = JSON.parse(localStorage.getItem('surveys') || '[]')
    const filtered = filter(surveys, { bce: formatted })

    let canProceed = true
    if (filtered.length > 0) {
      let i = 0
      while (i < filtered.length && canProceed) {
        let j = 0
        while (j < filtered[i]?.surveySessions.length && canProceed) {
          const status = filtered[i]?.surveySessions[j]?.status
          canProceed = status === 'completed'
          j++
        }
        i++
      }
    }

    if (!canProceed) {
      setErrorMessage(t('survey.create.stepper.errorStarted'))
      return false
    }

    try {
      const response = await getEnterpriseData(formatted, token)

      if (!response?.content?.enterprise) {
        setErrorMessage(t('survey.create.stepper.errorNotCompany'))
        return false
      }

      const ent = response.content.enterprise
      setBceValue(ent?.identification?.enterpriseNumber || '')

      // ---------------------------------------------------------
      //  CORRECTION MAJEURE : utiliser le NACE principal BCE
      // ---------------------------------------------------------
      let naceCodes = []

      // 1) d'abord le code officiel BCE
      const mainNace = ent?.identification?.mainActivity?.code
      if (mainNace) {
        naceCodes.push(mainNace)
      }

      // 2) fallback sur activitiesByNace si dispo
      if (naceCodes.length === 0 && ent?.activities?.activitiesByNace) {
        ent.activities.activitiesByNace.forEach((n) => {
          if (n.code) naceCodes.push(n.code)
        })
      }

      naceCodes = uniq(naceCodes).filter(Boolean)

      if (naceCodes.length > 0) {
        const arrayOfSectors = await getNaceWithSector(naceCodes, token)
        setSectors(arrayOfSectors)
      } else {
        setSectors([])
      }

      setEnterpriseName(ent?.identification?.name || '')
      setAddress({
        postCode: ent?.identification?.address?.postalCode,
        province: ent?.identification?.address?.province?.label
      })

      return true
    } catch (error) {
      console.log(error)
      setErrorMessage(t('survey.create.stepper.errorTimeout'))
      return false
    }
  }

  return {
    enterpriseName,
    sectors,
    address,
    bceValue,
    errorBce,
    errorMessage,
    fetchEnterprise
  }
}
